import Navbar from '@/components/Navbar'

export const laureates = [{
    path: '/laureates',
    redirect: '/laureates/list',
    component: Navbar,
    children: [{
        path: '/laureates/list',
        meta: {
            title: '获奖人-未来科学大奖'
        },
        name: 'laureates',
        component: () =>
            import ('@/views/laureates/list')
    }]
}]